import { RetiredStaticBundleComponentParent } from "../../../../types/types";

type Props = {
  product: RetiredStaticBundleComponentParent;
};

export const BundleDescriptionLinks = ({ product }: Props) => {
  const { links = [] } = product;
  const hasLinks = links.length > 0;

  if (!hasLinks) return null;

  return (
    <>
      <ul data-testid="bundleProductDescription:links">
        {links.map(({ linkUrl, text }) => (
          <li key={linkUrl}>
            <a data-testid="bundleProductDescription:links:link" href={linkUrl}>
              {text}
            </a>
          </li>
        ))}
      </ul>
    </>
  );
};
